import React from "react";
import { X, Maximize, Minimize, ArrowUpRight } from "lucide-react";
import CreateWidgetButton from "./CreateWidgetButton";

const ChatHeader = ({
  isExpanded,
  handleExpand,
  handleClose,
  handleContinueInNova,
  handleCreateWidget,
  isCreatingWidget,
  useNovaV2,
  onToggleV2
}) => {
  return (
    <div
      className="flex justify-between items-center px-4 shrink-0"
      style={{
        height: '56px',
        background: 'linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      }}
      role="banner"
    >
      <div className="flex items-center gap-2.5">
        <div
          className="w-2.5 h-2.5 rounded-full"
          style={{ backgroundColor: 'rgba(255,255,255,0.8)' }}
        />
        <span className="font-semibold text-base text-white tracking-wide select-none">NOVA</span>
        <button
          type="button"
          onClick={onToggleV2}
          title={useNovaV2 ? "Switch to original endpoint" : "Switch to v2 endpoint"}
          className="ml-1 px-2 py-0.5 text-xs font-semibold rounded-full border transition-colors"
          style={useNovaV2
            ? { backgroundColor: 'rgba(255,255,255,0.9)', color: 'var(--color-primary)', borderColor: 'rgba(255,255,255,0.9)' }
            : { backgroundColor: 'transparent', color: 'rgba(255,255,255,0.6)', borderColor: 'rgba(255,255,255,0.4)' }}
        >
          v2
        </button>
      </div>

      <div className="flex items-center gap-2">
        <CreateWidgetButton
          onCreateWidget={handleCreateWidget}
          isCreating={isCreatingWidget}
        />
        <div className="flex gap-1">
          <button
            type="button"
            aria-label="Open in NOVA"
            onClick={handleContinueInNova}
            className="flex items-center justify-center w-8 h-8 rounded-lg transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
            style={{ color: 'rgba(255,255,255,0.75)' }}
            onMouseEnter={e => e.currentTarget.style.color = 'white'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
          >
            <ArrowUpRight size={18} />
          </button>
          <button
            type="button"
            aria-label={isExpanded ? 'Minimize' : 'Maximize'}
            onClick={handleExpand}
            className="flex items-center justify-center w-8 h-8 rounded-lg transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
            style={{ color: 'rgba(255,255,255,0.75)' }}
            onMouseEnter={e => e.currentTarget.style.color = 'white'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
          >
            {isExpanded ? <Minimize size={17} /> : <Maximize size={17} />}
          </button>
          <button
            type="button"
            aria-label="Close chat"
            onClick={handleClose}
            className="flex items-center justify-center w-8 h-8 rounded-lg transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
            style={{ color: 'rgba(255,255,255,0.75)' }}
            onMouseEnter={e => e.currentTarget.style.color = 'white'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
          >
            <X size={17} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
